<template>
    <div>
        <v-autocomplete
            v-model="model"
            :items="results"
            :loading="isLoading"
            :search-input.sync="input"
            placeholder="Search for a city..."
            no-filter
            hide-no-data
            solo
            return-object
            @change="onChange">
            <template v-slot:item="{ item }">
                <v-list-item-content>
                    <v-list-item-title v-html="item.name"></v-list-item-title>
                    <v-list-item-subtitle v-html="item.address"></v-list-item-subtitle>
                </v-list-item-content>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
import Vue from 'vue';
import { api } from '../services/api';

export default Vue.extend({
    name: 'CityAutocomplete',

    data() {
        return {
            model: '',
            input: '',
            lastSearchValue: null,
            results: [],
            isLoading: false,

            searchTimeout: null,
        };
    },

    watch: {
        input(value) {
            // Items have already been loaded
            if (this.lastSearchValue === value) {
                return;
            }

            if (!value || value.length < 3) {
                return;
            }

            // Items have already been requested
            // if (this.isLoading) {
            //     return;
            // }

            this.search(value);
        },
    },

    methods: {
        search(value) {
            clearTimeout(this.searchTimeout);

            this.searchTimeout = setTimeout(() => {
                this.lastSearchValue = value;
                this.isLoading = true;
                api.get(
                    'geo/search',
                    {
                        q: value,
                    },
                )
                    .then((result) => {
                        this.results = result.locations.map((location) => ({
                            name: location.name,
                            address: location.address.formatted,
                            value: `/near/${location.lat},${location.lon}`,
                            lat: location.lat,
                            lon: location.lon,
                        }));
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }, 500);
        },

        onChange() {
            this.$emit('select', this.model);
        },
    },
});
</script>
